import React from 'react';
import { connect } from 'react-redux';
import { ProGallery } from '../common';
import { LOADING_HASHTAG_HEIGHT } from '../../../constants';
import { GALLERY_TYPES } from '../../../constants/proGalleryConstants';
import useCreateThumbnails from './hooks/useCreateThumbnails';

// Actions
import { eventsListenerProGallery } from '../../../actions/proGalleryActions';

// Style
import { st, classes } from './Hashtags.st.css';

const HashtagsGallery = ({
  eventsListenerProGallery,
  hashtagsData,
  height,
  heightShowMoreNeedToRemove,
  hashtagsLoading,
  isLoadingMedias,
  isMobile,
  padding,
}) => {
  const galleryRef = useCreateThumbnails(height);

  return (
    <div className={st(classes.root)} ref={galleryRef}>
      <ProGallery
        moreOptions={{ videoPlay: 'auto' }}
        paddingGallery={padding}
        eventsListener={eventsListenerProGallery}
        items={hashtagsData}
        galleryHeight={height}
        heightShowMoreNeedToRemove={heightShowMoreNeedToRemove}
        isLoadingItems={isLoadingMedias ? false : hashtagsLoading}
        isMobile={isMobile}
        type={GALLERY_TYPES.HASHTAG}
        loadingHeight={LOADING_HASHTAG_HEIGHT}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoadingMedias: state.appReducer.isLoadingMedias,
  isMobile: state.appReducer.isMobile,
  hashtagsData: state.appReducer.hashtagsData,
  height: state.galleryReducer.hashtags.height,
  padding: state.galleryReducer.hashtags.padding,
  heightShowMoreNeedToRemove:
    state.galleryReducer.hashtags.heightShowMoreNeedToRemove,
  cornerRadiusHashtag: state.settingsReducer.cornerRadiusHashtag,
  hashtagsLoading: state.appReducer.hashtagsLoading,
  direction: state.settingsReducer.direction,
  sliderArrowsPosition: state.settingsReducer.sliderArrowsPosition,
  sliderArrowsPadding: state.settingsReducer.sliderArrowsPadding,
  sliderArrowsSize: state.settingsReducer.sliderArrowsSize,
  m_sliderArrowsPosition: state.settingsReducer.m_sliderArrowsPosition,
  m_sliderArrowsPadding: state.settingsReducer.m_sliderArrowsPadding,
  m_sliderArrowsSize: state.settingsReducer.m_sliderArrowsSize,
});

const mapDispatchToProps = (dispatch) => ({
  eventsListenerProGallery: (eName, eData, type) =>
    dispatch(eventsListenerProGallery(eName, eData, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HashtagsGallery);
